import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Popup, Form, TextArea, Button, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {NEGATIVE_STATUS} from '../../constants';

class Comment extends Component {
  constructor(props) {
    super(props);
    this.state = {'isOpen': false, 'comment': ''};
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  handleOpen() {
    this.setState({'isOpen': true});
  }

  handleClose() {
    this.setState({'isOpen': false, 'comment': ''});
  }

  handleChange(event, {value}) {
    this.setState({'comment': value});
  }

  handleSave() {
    const {order} = this.props;

    this.props.saveDealerOrderComment(order.orderSequence, this.state.comment);
    this.handleClose();
  }

  render() {
    const {isOpen, comment} = this.state;
    const {order} = this.props;

    if (NEGATIVE_STATUS.includes(order.status)) {
      return null;
    }

    return (
      <Popup wide inverted
        on='click'
        position='top center'
        open={isOpen}
        onClose={this.handleClose}
        onOpen={this.handleOpen}
        trigger={<Icon link size='large' name='comment' color='blue' />}
      >
        <Form>
          <TextArea maxLength='100' rows='2' value={comment} onChange={this.handleChange} />
          <Button secondary type='button' content='CANCELAR' onClick={this.handleClose} />
          <Button primary type='button' content='GUARDAR' disabled={comment.length < 5} onClick={this.handleSave} />
        </Form>
      </Popup>
    );
  }
}

const {saveDealerOrderComment} = Actions;

export default connect(null, {saveDealerOrderComment})(Comment);
